import {useEffect, useState} from 'react'
import {
  CREATE_VENDOR,
  GETLANGUAGE,
  GET_ALL_VENDORS,
  GET_VENDOR_BY_ID,
  UPDATE_VENDOR,
} from '../../../../utils/GraphQLAPI'
import Breadcrumbs from '../../../sharedComponent/Breadcrumbs/Breadcrumbs'
import SearchList from '../../../sharedComponent/SearchList/SearchList'
import {useLazyQuery, useMutation, useQuery} from '@apollo/client'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {alert} from '../../../../utils/helper'
import plusIcon from '../../../../_metronic/images/smlplus.svg'
import SharedModal from '../../../sharedComponent/SharedModal'
import {Spinner} from 'react-bootstrap'
import TextField from '../../../sharedComponent/TextField/TextField'
import {VTEXTS, listConfigs, defaultVendorProps, validationSchema} from './VendorUtils'
import {GLOBAL_CONSTANTS} from '../../../../utils/GlobalConstants'
import {dropdownMenuItemsType} from '../../../sharedComponent/SearchList/SearchList.types'

export const Vendors = () => {
  const [filterOptions, setFilterOptions] = useState({
    page: 1,
    perPage: 10,
    searchText: '',
  })
  const [modalConfig, setModalConfig] = useState({
    show: false,
    mode: 'CREATE',
  })
  const [getAllVendors, {loading: listLoading, data: vendors}] = useLazyQuery(GET_ALL_VENDORS, {
    variables: {
      getAllvendorInputs: filterOptions,
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  const [createVendor] = useMutation(CREATE_VENDOR, {
    onCompleted: () => {
      alert(VTEXTS.addModalSuccess, 'success')
      handleModalClose()
      getAllVendors()
    },
    onError: (err) => {
      handleModalClose()
      alert(err.message, 'error')
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
  })
  const [updateVendor] = useMutation(UPDATE_VENDOR, {
    onCompleted: () => {
      handleModalClose()
      alert(VTEXTS.editModalSuccess, 'success')
      getAllVendors()
    },
    onError: (err) => {
      alert(err.message, 'error')
    },

    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
  })
  const {data: languages} = useQuery(GETLANGUAGE)
  const [getVendorById, {loading: getLoading}] = useLazyQuery(GET_VENDOR_BY_ID, {
    onCompleted: ({getVendorById}) => {
      const englishId = languages.getAllLanguages.filter(
        ({languageName}: any) => languageName === 'English'
      )[0]?.id
      const spanishId = languages.getAllLanguages.filter(
        ({languageName}: any) => languageName === 'Spanish'
      )[0]?.id
      const englishNumber = getVendorById?.vendorNumbers.filter(
        (number: any) => number.language.id === englishId
      )[0]?.vendorNumber
      const spanishNumber = getVendorById?.vendorNumbers.filter(
        (number: any) => number.language.id === spanishId
      )[0]?.vendorNumber
      formik.setValues({
        vendorFirstName: getVendorById?.vendorFirstName,
        vendorLastName: getVendorById?.vendorLastName,
        vendorEmail: getVendorById?.vendorEmailId,
        vendorPhoneNumberEnglish: englishNumber,
        vendorPhoneNumberSpanish: spanishNumber,
        id: getVendorById?.id,
      })
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  const formik: any = useFormik({
    initialValues: defaultVendorProps,
    validationSchema: Yup.object().shape(validationSchema),
    enableReinitialize: true,
    onSubmit: (values) => {
      const englishId = languages.getAllLanguages.filter(
        ({languageName}: any) => languageName === 'English'
      )[0]?.id
      const spanishId = languages.getAllLanguages.filter(
        ({languageName}: any) => languageName === 'Spanish'
      )[0]?.id
      if (modalConfig.mode === 'CREATE') {
        if (englishId && spanishId) {
          createVendor({
            variables: {
              createVendorInput: {
                vendorEmail: values.vendorEmail,
                vendorFirstName: values.vendorFirstName,
                vendorLastName: values.vendorLastName,
                vendorNumbers: [
                  {
                    languageId: englishId,
                    number: values.vendorPhoneNumberEnglish,
                  },
                  {
                    languageId: spanishId,
                    number: values.vendorPhoneNumberSpanish,
                  },
                ],
              },
            },
          })
        }
      } else {
        updateVendor({
          variables: {
            updateVendorInput: {
              id: values.id,
              vendorFirstName: values.vendorFirstName,
              vendorLastName: values.vendorLastName,
              vendorNumber: [
                {
                  vendorId: values.id,
                  languageId: englishId,
                  number: values.vendorPhoneNumberEnglish,
                },
                {
                  vendorId: values.id,
                  languageId: spanishId,
                  number: values.vendorPhoneNumberSpanish,
                },
              ],
            },
          },
        })
      }
    },
  })
  //effect
  useEffect(() => {
    getAllVendors()
  }, [])
  //handlingfns
  const handleEdit = (id: string) => {
    getVendorById({
      variables: {
        getVendorById: id,
      },
    })
    setModalConfig({
      mode: 'EDIT',
      show: true,
    })
  }
  const dropdownMenuItems: dropdownMenuItemsType[] = [
    {
      name: 'Edit',
      callBack: handleEdit,
    },
  ]
  const handleModalClose = () => {
    setModalConfig({
      ...modalConfig,
      show: false,
    })
    formik.setTouched({})
    formik.setValues(defaultVendorProps)
  }
  return (
    <>
      <Breadcrumbs title='Vendors' subTitle='Home - Vendors' />
      <SearchList
        idFieldName='id'
        filterOptions={filterOptions}
        setFilterOptions={setFilterOptions}
        listCount={vendors?.getAllVendors?.totalCount}
        paginatedCount={vendors?.getAllVendors?.vendorList.length}
        listLoading={listLoading}
        toolbar={
          <>
            <button
              className='btn btn-primary fs-6 px-5 py-3 ms-5'
              name='open-modal'
              type='button'
              data-testid='open-modal'
              onClick={() => {
                formik.setValues(defaultVendorProps)
                setModalConfig({
                  mode: 'CREATE',
                  show: true,
                })
              }}
            >
              <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
              <span>{VTEXTS.addModalHeader}</span>
            </button>
          </>
        }
        apiData={vendors?.getAllVendors?.vendorList}
        listConfigs={listConfigs}
        dropdownMenuItems={dropdownMenuItems}
        isActiveApiFieldName=''
      />
      <SharedModal
        className='modal-dialog modal-dialog-centered modal-dialog-scrollable mw-650px'
        show={modalConfig.show}
        headerName={modalConfig.mode === 'CREATE' ? VTEXTS.addModalHeader : VTEXTS.editModalHeader}
        handleClose={handleModalClose}
        handleSubmit={() => formik.submitForm()}
      >
        {getLoading ? (
          <div className='text-center h-300px'>
            <Spinner animation='border' className='text-gray-600' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div className='p-5'>
            <TextField
              fieldName='vendorFirstName'
              formik={formik}
              fieldTitle='First Name'
              filedTitleMandatory={true}
            />
            <TextField
              fieldName='vendorLastName'
              formik={formik}
              fieldTitle='Last Name'
              filedTitleMandatory={false}
            />
            <TextField
              fieldName='vendorEmail'
              formik={formik}
              fieldTitle='Email ID'
              filedTitleMandatory={true}
              disabled={modalConfig.mode === 'EDIT'}
            />
            <label className='d-flex align-items-center mb-2 required mt-2'>
              <span className='fs-6 fw-semibold lh-23px'>Call forward Number for English</span>
            </label>
            <div className='d-flex'>
              <input
                type='text'
                value='+1'
                className='form-control form-control-lg form-control-solid'
                disabled
                style={{
                  width: '10%',
                  padding: '7px',
                  borderTopRightRadius: '0px',
                  borderBottomRightRadius: '0px',
                }}
              />
              <input
                type='text'
                id='customerPrimaryPhoneNumber'
                className='form-control form-control-lg form-control-solid'
                name='vendorPhoneNumberEnglish'
                placeholder='Enter Phone number'
                maxLength={10}
                {...formik.getFieldProps('vendorPhoneNumberEnglish')}
                onChange={(e) => {
                  formik.setFieldValue('vendorPhoneNumberEnglish', e.target.value)
                }}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderTopLeftRadius: '0px',
                  borderBottomLeftRadius: '0px',
                }}
              />
            </div>
            {formik.errors.vendorPhoneNumberEnglish && formik.touched.vendorPhoneNumberEnglish && (
              <div className='fv-plugins-message-container'>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  {formik.errors.vendorPhoneNumberEnglish}
                </div>
              </div>
            )}
            <label className='d-flex align-items-center mb-2 required mt-2'>
              <span className='fs-6 fw-semibold lh-23px'>Call forward Number for Spanish</span>
            </label>
            <div className='d-flex'>
              <input
                type='text'
                value='+1'
                className='form-control form-control-lg form-control-solid'
                disabled
                style={{
                  width: '10%',
                  padding: '7px',
                  borderTopRightRadius: '0px',
                  borderBottomRightRadius: '0px',
                }}
              />
              <input
                type='text'
                id='customerPrimaryPhoneNumber'
                className='form-control form-control-lg form-control-solid'
                name='vendorPhoneNumberSpanish'
                placeholder='Enter Phone number'
                maxLength={10}
                {...formik.getFieldProps('vendorPhoneNumberSpanish')}
                onChange={(e) => {
                  formik.setFieldValue('vendorPhoneNumberSpanish', e.target.value)
                }}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderTopLeftRadius: '0px',
                  borderBottomLeftRadius: '0px',
                }}
              />
            </div>
            {formik.errors.vendorPhoneNumberSpanish && formik.touched.vendorPhoneNumberSpanish && (
              <div className='fv-plugins-message-container'>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  {formik.errors.vendorPhoneNumberSpanish}
                </div>
              </div>
            )}
          </div>
        )}
      </SharedModal>
    </>
  )
}
